import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthState } from "@atlas/auth";

/**
 * OAuth callback page
 * Handles redirect from Cognito after social login (Google/Apple)
 * The AuthProvider's Hub listener will update auth state automatically
 */
export function AuthCallbackPage(): React.ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthState();

  useEffect(() => {
    // Wait for auth state to settle after OAuth redirect
    if (!isLoading) {
      if (isAuthenticated) {
        // Get the intended destination from state or default to home
        const from = (location.state as { from?: string })?.from ?? "/";
        navigate(from, { replace: true });
      } else {
        // Auth failed - redirect to login
        navigate("/login", { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, navigate, location.state]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg">
      <p className="text-text-secondary text-sm">Completing sign in...</p>
    </div>
  );
}
